// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*** 수당포함여부 섹션 ***/
.AllowanceBox {
  display: flex;
  flex-direction: column;
}

.AllowanceItem {
  display: flex;
  position: relative;
  cursor: pointer;
}

.AllowanceItem:not(:first-child) {
  margin-top: 20px;
}

.AllowanceItem input {
  display: none;
}

.AllowanceItem > input:checked ~ label:before {
  width: 13px;
  border-width: 2px;
  border-color: transparent #bc1a21 #bc1a21 transparent;
  transition: 0.2s;
  transform: rotate(30deg);
  transform-origin: 15px 15px;
}

.AllowanceItem label {
  position: relative;
  flex: 1 1;
  display: flex;
  padding: 0 0 0 30px;
  margin: 0;
  font: 0.9rem "Noto Sans KR";
  cursor: pointer;
}

.AllowanceItem label:before {
  content: "";
  position: absolute;
  left: 0;
  display: block;
  width: 20px;
  height: 20px;
  border: 1px solid #ddd;
  transition: 0.2s;
}

/************* 출퇴근기록 수정 모달 ************/
.modModal {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5%;
}

.modModalCnt {
  display: flex;
  flex-direction: column;
  min-width: 500px;
}

/* 상단 타이틀과 설명글, 그리고 날짜 들어 있음 */
.modModalCntTop {
  display: flex;
  justify-content: space-between;
}

/* 상단 타이틀 + 설명글 */
.topLeft {
  display: flex;
  flex-direction: column;
}

.topLeft strong {
  font-size: 1.2rem;
  font-family: "Noto Sans KR";
  margin-bottom: 2%;
}

.topLeft span {
  font-size: 0.9rem;
  font-family: "Noto Sans KR";
}

/* 날짜 */
.topRight {
  display: flex;
  font-size: 1.2rem;
  font-family: "Noto Sans KR";
  gap: 10px;
}

/* 출퇴근기록 수정 내용들 */
.modModalCntBody {
  margin: 2% 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

/* 출퇴근기록 수정 내용 섹션별 */
.modModalCntSection {
  display: flex;
  padding: 2% 5%;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
}

/* 유급 휴무설정 내용 섹션별 */
.modModalCntSection2 {
  display: flex;
  padding: 2% 5%;
  align-items: center;
  justify-content: space-between;
}

/* 무급 휴무설정 내용 섹션별 */
.modModalCntSection3 {
  display: flex;
  flex-direction: column;
}

/* 섹션별 왼쪽 내용 */
.sectionLeft {
  font: 1rem "Noto Sans KR";
}

/* 섹션별 오른쪽 내용 */
.sectionRight {
  display: flex;
  position: relative;
  min-width: 180px;
  width: 50%;
  text-align: center;
  align-content: center;
  justify-content: center;
}
.sectionRight button {
  z-index: 1;
  position: absolute;
  top: 0;
  left: -70px;
  bottom: 0;
  padding: 0 5px;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}
.sectionRight button:hover {
  border-color: #999;
}

.restTimeInputArea {
  position: relative;
  width: 100%;
}

.restTimeInput {
  width: 100%;
  height: 45px;
  font-size: 14px;
  text-align: right;
  padding-right: 20%;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}

.restTimeText {
  display: flex;
  position: absolute;
  top: 0;
  right: 10%;
  bottom: 0;
  color: #aaa;
  align-items: center;
}

/* 하단의 수정, 취소 버튼 들어있음 */
.modModalBtnArea {
  display: flex;
  justify-content: center;
  padding: 5%;
  /* border: 1px solid red */
}

.modModalBtnArea button {
  margin-left: 10px;
  width: 100px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 10px;
  font: 0.76rem "Noto Sans KR";
  text-align: center;
  outline: none;
  letter-spacing: 2px;
}

.modModalBtnArea button:hover {
  border: 1px solid #555;
}

.modModalBtnArea button.holiday {
  border: 1px solid #1ab394;
  color: #1ab394;
}

.modModalBtnArea button.holiday:hover {
  color: #fff;
  background-color: #1ab394;
}

.modModalBtnArea button.holiday2 {
  border: 1px solid #aaa;
  color: #aaa;
  background-color: #eee;
}

.modModalBtnArea button.holiday3 {
  border: 1px solid #bc1a21;
  color: #bc1a21;
}

.modModalBtnArea button.holiday3:hover {
  color: #fff;
  background-color: #bc1a21;
}`, "",{"version":3,"sources":["webpack://./src/components/commuting/CommuteModify/CommuteModify.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAZ,kBAAA;AACA;EACI,aAAA;EACA,sBAAA;AAER;;AAAI;EACI,aAAA;EACA,kBAAA;EACA,eAAA;AAGR;;AADI;EACI,gBAAA;AAIR;;AAFI;EACI,aAAA;AAKR;;AAHI;EACI,WAAA;EACA,iBAAA;EACA,qDAAA;EACA,gBAAA;EACA,wBAAA;EACA,2BAAA;AAMR;;AAJI;EACI,kBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;AAOR;;AALI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAQR;;AANA,uCAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AASJ;;AAPA;EACG,aAAA;EACA,sBAAA;EACA,gBAAA;AAUH;;AAPA,8BAAA;AACA;EACI,aAAA;EACA,8BAAA;AAUJ;;AAPI,iBAAA;AACA;EACI,aAAA;EACA,sBAAA;AAUR;;AARI;EACI,iBAAA;EACA,2BAAA;EACA,iBAAA;AAWR;;AATI;EACI,iBAAA;EACA,2BAAA;AAYR;;AATI,OAAA;AACA;EACI,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,SAAA;AAYR;;AATA,iBAAA;AACA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAYJ;;AATI,oBAAA;AACA;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;AAYR;;AAVI,mBAAA;AACA;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;AAaR;;AAXI,mBAAA;AACA;EACI,aAAA;EACA,sBAAA;AAcR;;AAXI,cAAA;AACA;EACI,yBAAA;AAcR;;AAXI,eAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;AAcR;AAZQ;EACI,UAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAcZ;AAZY;EACI,kBAAA;AAchB;;AAVI;EACI,kBAAA;EACA,WAAA;AAaR;;AAXQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAcZ;;AAZQ;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAeZ;;AAZA,uBAAA;AACA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,0BAAA;AAeJ;;AAbI;EACI,iBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAgBR;;AAdQ;EACI,sBAAA;AAiBZ;;AAfQ;EACI,yBAAA;EACA,cAAA;AAkBZ;;AAhBQ;EACI,WAAA;EACA,yBAAA;AAmBZ;;AAjBQ;EACI,sBAAA;EACA,WAAA;EACA,sBAAA;AAoBZ;;AAlBQ;EACI,yBAAA;EACA,cAAA;AAqBZ;;AAnBQ;EACI,WAAA;EACA,yBAAA;AAsBZ","sourcesContent":["    /*** 수당포함여부 섹션 ***/\n    .AllowanceBox {\n        display: flex;\n        flex-direction: column;\n    }\n    .AllowanceItem {\n        display: flex;\n        position: relative;\n        cursor: pointer;\n    }\n    .AllowanceItem:not(:first-child) {\n        margin-top: 20px;\n    }\n    .AllowanceItem input {\n        display: none;\n    }\n    .AllowanceItem>input:checked~label:before {\n        width: 13px;\n        border-width: 2px;\n        border-color: transparent #bc1a21 #bc1a21 transparent;\n        transition: .2s;\n        transform: rotate(30deg);\n        transform-origin: 15px 15px;\n    }\n    .AllowanceItem label {\n        position: relative;\n        flex: 1;\n        display: flex;\n        padding: 0 0 0 30px;\n        margin: 0;\n        font: 0.9rem 'Noto Sans KR';\n        cursor: pointer;\n    }\n    .AllowanceItem label:before {\n        content: '';\n        position: absolute;\n        left: 0;\n        display: block;\n        width: 20px;\n        height: 20px;\n        border: 1px solid #ddd;\n        transition: .2s;\n    }\n/************* 출퇴근기록 수정 모달 ************/\n.modModal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 5%;\n}\n.modModalCnt {\n   display: flex;\n   flex-direction: column;\n   min-width: 500px;\n}\n\n/* 상단 타이틀과 설명글, 그리고 날짜 들어 있음 */\n.modModalCntTop {\n    display: flex;\n    justify-content: space-between;\n}\n\n    /* 상단 타이틀 + 설명글 */\n    .topLeft {\n        display: flex;\n        flex-direction: column;\n    }\n    .topLeft strong {\n        font-size: 1.2rem;\n        font-family: 'Noto Sans KR';\n        margin-bottom: 2%;\n    }\n    .topLeft  span {\n        font-size: 0.9rem;\n        font-family: 'Noto Sans KR';\n    }\n\n    /* 날짜 */\n    .topRight {\n        display: flex;\n        font-size: 1.2rem;\n        font-family: 'Noto Sans KR';\n        gap: 10px;\n    }\n\n/* 출퇴근기록 수정 내용들 */\n.modModalCntBody {\n    margin: 2% 0;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n}\n\n    /* 출퇴근기록 수정 내용 섹션별 */\n    .modModalCntSection {\n        display: flex;\n        padding: 2% 5%;\n        align-items: center;\n        justify-content: space-between;\n        border-bottom: 1px solid #ddd;\n    }\n    /* 유급 휴무설정 내용 섹션별 */\n    .modModalCntSection2 {\n        display: flex;\n        padding: 2% 5%;\n        align-items: center;\n        justify-content: space-between;\n    }\n    /* 무급 휴무설정 내용 섹션별 */\n    .modModalCntSection3 {\n        display: flex;\n        flex-direction: column;\n    }\n\n    /* 섹션별 왼쪽 내용 */\n    .sectionLeft {\n        font: 1rem 'Noto Sans KR';\n    }\n\n    /* 섹션별 오른쪽 내용 */\n    .sectionRight {\n        display: flex;\n        position: relative;\n        min-width: 180px;\n        width: 50%;\n        text-align: center;\n        align-content: center;\n        justify-content: center;\n\n        button {\n            z-index: 1;\n            position: absolute;\n            top: 0;\n            left: -70px;\n            bottom: 0;\n            padding: 0 5px;\n            border: 1px solid #e9e9e9;\n            border-radius: 8px;\n\n            &:hover {\n                border-color: #999;\n            }\n        }\n    }\n    .restTimeInputArea {\n        position: relative;\n        width: 100%;\n    }\n        .restTimeInput {\n            width: 100%;\n            height: 45px;\n            font-size: 14px;\n            text-align: right;\n            padding-right: 20%;\n            border: 1px solid #e9e9e9;\n            border-radius: 8px;\n        }\n        .restTimeText {\n            display: flex;\n            position: absolute;\n            top: 0;\n            right: 10%;\n            bottom: 0;\n            color: #aaa;\n            align-items: center;\n        }\n    \n/* 하단의 수정, 취소 버튼 들어있음 */\n.modModalBtnArea {\n    display: flex;\n    justify-content: center;\n    padding: 5%;\n    /* border: 1px solid red */\n}\n    .modModalBtnArea button {\n        margin-left: 10px;\n        width: 100px;\n        height: 30px;\n        background: #fff;\n        border: 1px solid #ccc;\n        -moz-border-radius: 10px;\n        border-radius: 10px;\n        font: 0.76rem 'Noto Sans KR';\n        text-align: center;\n        outline: none;\n        letter-spacing: 2px;\n    }\n        .modModalBtnArea button:hover {\n            border: 1px solid #555;\n        }\n        .modModalBtnArea button.holiday {\n            border: 1px solid#1ab394;\n            color:#1ab394;\n        }\n        .modModalBtnArea button.holiday:hover {\n            color:#fff;\n            background-color: #1ab394;\n        }\n        .modModalBtnArea button.holiday2 {\n            border: 1px solid#aaa;\n            color:#aaa;\n            background-color: #eee;\n        }\n        .modModalBtnArea button.holiday3 {\n            border: 1px solid #bc1a21;\n            color: #bc1a21;\n        }\n        .modModalBtnArea button.holiday3:hover {\n            color:#fff;\n            background-color: #bc1a21;\n        }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
